import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Login from '../views/Login'
import Dashboard from '../views/Dashboard'
import CustomerList from '../views/CustomerList'
import Customer from '../views/Customer'
import CustomerProperties from '../views/CustomerProperties'
import CustomerSchedule from '../views/CustomerSchedule'
import Tasks from '../views/Tasks'
import TaskGroups from '../views/TaskGroups'
import Settings from '../views/Settings'
import Profile from '../views/Profile'
import VehicleList from '../views/VehicleList'
import Vehicle from '../views/Vehicle'
import VehicleTracking from '../views/VehicleTracking'
import AllBookings from '../views/AllBookings'
import BookingCalendarView from '../views/BookingCalendarView'
import ListView from '../views/ListView'
import ProjectsView from '../views/ProjectsView'
import ProjectView from '../views/ProjectView'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/customers',
    name: 'CustomerList',
    component: CustomerList
  },
  {
    path: '/customer/:customer',
    name: 'Customer',
    component: Customer,
    props: true
  },
  {
    path: '/customer/:customer/schedules',
    name: 'CustomerSchedule',
    component: CustomerSchedule,
    props: true
  },
  {
    path: '/customer/:customer/properties',
    name: 'CustomerProperties',
    component: CustomerProperties,
    props: true
  },
  {
    path: '/all-bookings',
    name: 'AllBookings',
    component: AllBookings
  },
  {
    path: '/all-bookings/calendar',
    name: 'BookingCalendarView',
    component: BookingCalendarView
  },
  {
    path: '/tasks',
    name: 'Tasks',
    component: Tasks
  },
  {
    path: '/tasks-groups',
    name: 'TaskGroups',
    component: TaskGroups
  },
  {
    path: '/vehicles',
    name: 'VehicleList',
    component: VehicleList
  },
  {
    path: '/vehicle/:vehicle',
    name: 'Vehicle',
    component: Vehicle,
    props: true
  },
  {
    path: '/vehicle/:vehicle/tracking',
    name: 'VehicleTracking',
    component: VehicleTracking,
    props: true
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings
  },
  {
    path: '/my-profile',
    name: 'Profile',
    component: Profile
  },
  {
    path: '/lists',
    name: 'ListView',
    component: ListView
  },
  {
    path: '/projects',
    name: 'ProjectsView',
    component: ProjectsView
  },
  {
    path: '/project/:id',
    name: 'ProjectView',
    component: ProjectView,
    props: true
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (!store.state.auth && to.name !== 'Login') next({ name: 'Login' })
  if (store.state.auth && to.name === 'Login') next({ name: 'Dashboard' })
  else next()
})

export default router
